import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Check, Phone, ChevronRight, Handshake } from 'lucide-react';
import { company } from '../mock';
import Seo from '../components/Seo';
import StructuredData from '../components/StructuredData';
import TradePartnerForm from '../components/TradePartnerForm';
import StickyBookBar from '../components/StickyBookBar';

const BENEFITS = [
  { t: 'Reliable, on-time scheduling', s: 'We show up when we say we will and coordinate around your other trades to keep the build moving.' },
  { t: 'Licensed, insured & certified', s: 'Class II Unrestricted Master Plumber (MP#210521), GBPAT & Treeo backflow certified, fully insured.' },
  { t: 'Permits & inspections handled', s: 'We provide stand-alone plumbing permits and work directly with city inspectors so your job stays compliant.' },
  { t: 'Rough-in to finish', s: 'From underground and rough-in through fixture set and trim-out on residential and commercial projects.' },
  { t: 'Clear communication', s: 'One dependable point of contact and straightforward updates through every phase of the project.' },
  { t: 'Standardized quality process', s: 'A consistent safety and quality procedure on every job, so the work is done right the first time.' },
];

export default function TradePartnerPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const breadcrumbs = [
    { name: 'Home', path: '/' },
    { name: 'Construction', path: '/commercial' },
    { name: 'Trade Partners', path: '/trade-partner' },
  ];

  return (
    <main className="page trade-page" data-testid="trade-partner-page">
      <Seo title="Become a Trade Partner" description="Partner with Victory Plumbing as your plumbing subcontractor in Savannah, GA. Reliable rough-ins, finish plumbing, permits & on-time scheduling for builders & GCs." path="/trade-partner" />
      <StructuredData business={false} service={{ name: 'Plumbing Trade Partner Program', serviceType: 'Plumbing Subcontractor', description: 'Plumbing subcontractor partnership for builders and general contractors in Savannah, GA.', path: '/trade-partner' }} breadcrumbs={breadcrumbs} />

      <section className="page-hero landing-hero">
        <div className="wrap">
          <div className="landing-hero-copy">
            <nav className="crumbs" aria-label="Breadcrumb" data-testid="breadcrumbs">
              {breadcrumbs.map((c, i) => (
                <React.Fragment key={c.path}>
                  {i > 0 && <ChevronRight className="sep" size={13} />}
                  {i < breadcrumbs.length - 1
                    ? <Link to={c.path}>{c.name}</Link>
                    : <span className="current" aria-current="page">{c.name}</span>}
                </React.Fragment>
              ))}
            </nav>
            <p className="eyebrow"><Handshake size={16} style={{ verticalAlign: '-3px', marginRight: '6px' }} />For Builders &amp; General Contractors</p>
            <h1>Become a Trade Partner</h1>
            <p className="lede">Looking for a plumbing subcontractor you can count on? Partner with Victory Plumbing for dependable rough-ins, finish plumbing, permits, and on-time scheduling across Savannah and the Coastal Empire &mdash; backed by a Class II Master Plumber and a standardized safety process.</p>
            <div className="about-cta">
              <a className="btn btn-gold" href={company.phoneHref}><Phone size={15} /> Call {company.phoneDisplay}</a>
            </div>
          </div>
          <div id="request-service">
            <div className="lead-form-card">
              <TradePartnerForm />
            </div>
          </div>
        </div>
      </section>

      <section className="trade-benefits">
        <div className="wrap">
          <div className="sec-head" style={{ marginBottom: '28px' }}>
            <p className="eyebrow">Why Partner With Us</p>
            <h2>A plumbing partner your projects can rely on</h2>
            <p>We make it easy to add a trusted plumbing crew to your team &mdash; on new construction, renovations, and large-scale projects.</p>
          </div>
          <div className="trade-benefits-grid">
            {BENEFITS.map((b) => (
              <div className="trade-benefit" key={b.t}>
                <span className="tb-ic"><Check size={18} /></span>
                <div>
                  <h3>{b.t}</h3>
                  <p>{b.s}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <StickyBookBar bookHref="#request-service" bookLabel="Partner With Us" />
    </main>
  );
}
